import * as tConst from "../Common/Constants";

// Types for iteration and quarter headers
export type IterationHeader = [
  string, // "."
  string, // iteration name
  string, // period string
  string, // color
  Date,   // start date
  Date    // end date
];

export type QuarterHeader = [
  string, // "."
  string, // quarter name
  string, // period string
  string, // color
  Date,   // start date
  Date    // end date
];

interface Quarter {
  name: string;
  start: Date;
  end: Date;
}

// Utility to format date as 'd. MMM yyyy'
function formatDate(date: Date): string {
  const day = date.getDate();
  const month = date.toLocaleString('en', { month: 'short' });
  const year = date.getFullYear();
  return `${day}. ${month} ${year}`;
}

export function createQuarterHeader(iterationHeaders: IterationHeader[]): QuarterHeader[] {
  
  let quarterHeaders: QuarterHeader[] = [];
  if(iterationHeaders.length > 0) {

    const it = iterationHeaders[0]
    const _start: Date = it[4];
    const _end: Date = it[5];
    const _name =
    _start.getFullYear().toString().slice(-2) + "Q" + Math.ceil((_start.getMonth() + 1) / 3);
    
  
    let quarter: Quarter = {name: _name, start: _start, end: _end};
    iterationHeaders.forEach((iteration) => {
    const start: Date = iteration[4];
    const end: Date = iteration[5];
    const name =
    start.getFullYear().toString().slice(-2) + "Q" + Math.ceil((start.getMonth() + 1) / 3);
    
    if (quarter.name !== name) {
      // We are in a new quarter
      quarterHeaders.push([
        ".",
        quarter!.name,
        "Period: " + formatDate(quarter!.start) + " - " + formatDate(quarter!.end),
        tConst.COLOR_QUARTALS,
        quarter!.start,
        quarter!.end,
      ]);
      quarter = { name, start, end };
    } else {
      // we are in the same quarter and should just update
      quarter.end = end;
    }
  });
  
  // If there is a last quarter, push it to the headers
  if (quarter !== null) {
    quarterHeaders.push([
      ".",
      quarter.name,
      "Period: " + formatDate(quarter.start) + " - " + formatDate(quarter.end),
      tConst.COLOR_QUARTALS,
      quarter.start,
      quarter.end,
    ]);
  }
}
  return quarterHeaders;
}

export function iterationHeader(startDate: Date, endDate: Date ): IterationHeader[] {
  let iterationHeaderData: IterationHeader[] = [];
  let _startDate = new Date(2020, 0, 9, tConst.START_TIME);
  let _endDate = new Date(2020, 0, 23, tConst.END_TIME);
  let _testEndDate = new Date(2020, 0, 23, tConst.START_TIME);
  let _year = 20;
  let iterationNumber = 1;
  const now = new Date();
  while (_startDate < endDate) {
    if (_endDate < startDate) {
      //do nothing
    } else if (_startDate > endDate) {
      break;
    } else {
      iterationHeaderData.push([
        ".",
        _year.toString() + "T" + iterationNumber.toString(),
        "Period: " + formatDate(_startDate) + " - " + formatDate(_endDate),
        _startDate < now && _testEndDate > now
          ? tConst.COLOR_CURRENT_ITERATION
          : tConst.COLOR_ITERATION,
        new Date(_startDate.getTime()),
        new Date(_endDate.getTime()),
      ]);
    }
    _startDate.setDate(_startDate.getDate() + 14);
    _endDate.setDate(_endDate.getDate() + 14);
    _testEndDate.setDate(_testEndDate.getDate() + 14);

    if (_startDate.toLocaleDateString("en", { year: "2-digit" }) === _year.toString()) {
      iterationNumber++;
    } else {
      _year++;
      iterationNumber = 1;
    }
  }
  return iterationHeaderData;
}
